import * as React from 'react';
import { Select, SelectItem } from '@highereducation/hen-ui';
import { fieldName } from '../submit';
import {
  FieldLabel,
  FieldErrorMessage,
  type FieldComponentProps,
} from './parts';

/**
 * SELECT field — hen-ui `Select`. With `name`/`required` forwarded to the
 * underlying Radix root, it renders a hidden native `<select>` so the choice
 * participates in uncontrolled `FormData` submission.
 */
export function SelectField({ field, formId, error }: FieldComponentProps) {
  const name = fieldName(formId, field.id);
  const choices = field.choices ?? [];

  return (
    <>
      <FieldLabel field={field} htmlFor={name} />
      <Select
        id={name}
        name={name}
        required={Boolean(field.isRequired)}
        placeholder={field.placeholder || 'Select...'}
        error={Boolean(error)}
      >
        {choices.map((choice) => (
          <SelectItem key={choice.value} value={choice.value}>
            {choice.text}
          </SelectItem>
        ))}
      </Select>
      <FieldErrorMessage error={error} />
    </>
  );
}
